import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
//en
import enTranslation from '../locales/en/translation.json'
import enAboutus from '../locales/en/aboutus.json'
import enCommon from '../locales/en/common.json'
import enService from '../locales/en/service.json'
import enHome from '../locales/en/home.json'
import enStudent from '../locales/en/student.json'
import enSuperAdmin from '../locales/en/super-admin.json'
import enTeacher from '../locales/en/teacher.json'
import enParent from '../locales/en/parent.json';
import enAdmin from '../locales/en/admin.json'
import enEstablishment from '../locales/en/establishments.json'
// import enFeature from '../locales/en/feature.json'
import enFlashcard from '../locales/en/flashcard.json'
import enNotes from '../locales/en/notes.json'
// import enPublic from '../locales/en/public.json'
import enSchool from '../locales/en/school.json'
import enSchoolTemplateEditor from '../locales/en/school-template-editor.json'
import enTimetable from '../locales/en/admin-timetable.json'
import enAdminAttendance from '../locales/en/admin-attendance.json'
import enCard from '../locales/en/card.json'
import enAttendance from '../locales/en/attendance.json'
import enShared from '../locales/en/shared.json'
import en3d from '../locales/en/3d.json'
import enTour from '../locales/en/tour.json'
import enMockData from '../locales/en/mock-data.json'
import enB2CStudent from '../locales/en/b2c-student.json'
import enFeatures from '../locales/en/features.json'
import enAttestation from '../locales/en/attestation.json'
import enNationalities from '../locales/en/nationalities.json'
import enExamList from '../locales/en/exam-list.json'
import enPricing from '../locales/en/pricing.json'

//fr
import frTranslation from '../locales/fr/translation.json'
import frAboutus from '../locales/fr/aboutus.json'
import frCommon from '../locales/fr/common.json'
import frService from '../locales/fr/service.json'
import frHome from '../locales/fr/home.json'
import frStudent from '../locales/fr/student.json'
import frSuperAdmin from '../locales/fr/super-admin.json'
import frTeacher from '../locales/fr/teacher.json'
import frParent from '../locales/fr/parent.json';
import frAdmin from '../locales/fr/admin.json'
import frEstablishment from '../locales/fr/establishments.json'
// import frFeature from '../locales/fr/feature.json'
import frFlashcard from '../locales/fr/flashcard.json'
import frNotes from '../locales/fr/notes.json'
// import frPublic from '../locales/fr/public.json'
import frSchool from '../locales/fr/school.json'
import frSchoolTemplateEditor from '../locales/fr/school-template-editor.json'
import frTimetable from '../locales/fr/admin-timetable.json'
import frCard from '../locales/fr/card.json'
import frAdminAttendance from '../locales/fr/admin-attendance.json'
import frAttendance from '../locales/fr/attendance.json'
import frTour from '../locales/fr/tour.json'
import frShared from '../locales/fr/shared.json'
import fr3d from '../locales/fr/3d.json'
import frMockData from '../locales/fr/mock-data.json'
import frB2CStudent from '../locales/fr/b2c-student.json'
import frFeatures from '../locales/fr/features.json'
import frAttestation from '../locales/fr/attestation.json'
import frNationalities from '../locales/fr/nationalities.json'
import frExamList from '../locales/fr/exam-list.json'
import frPricing from '../locales/fr/pricing.json'

// Initialize i18next
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        translation: enTranslation,
        common: enCommon,
        home: enHome,
        student: enStudent,
        superAdmin: enSuperAdmin,
        teacher: enTeacher,
        parent: enParent,
        admin: enAdmin,
        establishment: enEstablishment,
        // feature: enFeature,
        flashcard: enFlashcard,
        notes: enNotes,
        // public: enPublic,
        school: enSchool,
        schoolTemplateEditor: enSchoolTemplateEditor,
        timetable: enTimetable,
        card: enCard,
        attendance: enAdminAttendance,
        shared: enShared,
        tour: enTour,
        studentAttendance: enAttendance,
        '3d': en3d,
        'b2c-student': enB2CStudent,
        mockData: enMockData,
        features: enFeatures,
        attestation: enAttestation,
        aboutus:enAboutus,
        service:enService,
        nationalities: enNationalities,
        'exam-list': enExamList,
        pricing: enPricing
      },
      fr: {
        translation: frTranslation,
        common: frCommon,
        home: frHome,
        student: frStudent,
        superAdmin: frSuperAdmin,
        teacher: frTeacher,
        parent: frParent,
        admin: frAdmin,
        establishment: frEstablishment,
        // feature: frFeature,
        flashcard: frFlashcard,
        notes: frNotes,
        // public: frPublic,
        school: frSchool,
        schoolTemplateEditor: frSchoolTemplateEditor,
        timetable: frTimetable,
        card: frCard,
        attendance: frAdminAttendance,
        shared: frShared,
        tour: frTour,
        studentAttendance: frAttendance,
        '3d': fr3d,
        'b2c-student': frB2CStudent,
        mockData: frMockData,
        features: frFeatures,
        attestation: frAttestation,
        aboutus:frAboutus,
        service:frService,
        nationalities: frNationalities,
        'exam-list': frExamList,
        pricing: frPricing
      },
    },
    fallbackLng: 'fr',
    supportedLngs: ['en', 'fr'],

    // Detect language from browser
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    },

    interpolation: {
      escapeValue: false,
    },

    // Enable debug mode to see what's happening
    debug: true,

    // Make sure i18n is initialized before rendering
    react: {
      useSuspense: false,
    },
  })

// Log the detected language
// console.log('Detected language:', i18n.language)
// console.log('i18n resources loaded:', i18n.options.resources)

// Add a function to manually change the language
export const changeLanguage = (lng: string) => {
  return i18n.changeLanguage(lng)
}

export default i18n
